import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSidebarToggle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "9 9 14 14",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M20.667 9.5C21.6793 9.50018 22.4998 10.3207 22.5 11.333V20.667C22.4998 21.6793 21.6793 22.4998 20.667 22.5H11.333C10.3207 22.4998 9.50018 21.6793 9.5 20.667V11.333C9.50018 10.3207 10.3207 9.50018 11.333 9.5H20.667ZM11.333 10.5C10.873 10.5002 10.5002 10.873 10.5 11.333V20.667C10.5002 21.127 10.873 21.4998 11.333 21.5H13.5V10.5H11.333ZM14.5 21.5H20.667C21.127 21.4998 21.4998 21.127 21.5 20.667V11.333C21.4998 10.873 21.127 10.5002 20.667 10.5H14.5V21.5Z",
		fill: "currentColor"
	})
});
export default SvgSidebarToggle;
